import * as React from 'react';
import DeleteIcon from '../../asset/icons/Delete.esm.js';
import { CartContext } from '../../context/CartContext.esm.js';
import { CartSettingsContext } from '../../context/CartSettingsContext.esm.js';
import 'tslib';
import 'lodash/isEqual';
import 'markdown-to-jsx';
import '@invitae/ids-react';
import 'lodash/isEmpty';
import '@invitae/analytics-queue';
import { isRnaAnalysisTestSelection } from './OrderCard.utils.esm.js';
import '../../constants/analytics.esm.js';
import '../../modals/content/index.esm.js';
import '../../modals/content/default_validation_error.esm.js';
import '../../modals/ModalBuilder.models.esm.js';
import 'squirrelly';
import '../../modals/postProcessingActions/processLocationValidationError.esm.js';
import '@invitae/stargate-ts-fetch';
import 'classnames';
import '../../constants/api.esm.js';
import { CUSTOM_ORDER_PANEL_NAME, LEGACY_CUSTOM_ORDER_PANEL_NAME } from '../../constants/customOrder.esm.js';
import useCollapsible from '../../utils/hooks/useCollapsible/useCollapsible.esm.js';
import pluralize from '../../utils/pluralize.esm.js';
import GeneList from './GeneList.esm.js';
import styles from './OrderCard.module.esm.js';

var getTotalGeneCount = function (_a) {
    var genes = _a.genes;
    // Some genes may actually represent few aggregated genes, their names equal something like this: "ABC, CD1".
    // We want to treat such genes as two genes instead of one.
    return genes.map(function (_a) {
        var name = _a.name;
        return name.split(',').length;
    }).reduce(function (acc, val) { return acc + val; }, 0);
};
var shouldShowSaveCustomPanelButton = function (_a) {
    var name = _a.name;
    return name === CUSTOM_ORDER_PANEL_NAME || name === LEGACY_CUSTOM_ORDER_PANEL_NAME;
};
var shouldHideGeneCountPanel = function (test) {
    return test.explicitGeneCount === 0 && !isRnaAnalysisTestSelection(test.name);
};
var shouldRenderDeleteButton = function (test, cartContext, cartSettings) {
    var _a;
    var meta = cartContext.meta;
    var isCompact = cartSettings.isCompact, isEditable = cartSettings.isEditable;
    var hideGeneCountPanel = shouldHideGeneCountPanel(test);
    return !hideGeneCountPanel && isEditable && !isCompact && !((_a = meta === null || meta === void 0 ? void 0 : meta.rereq) === null || _a === void 0 ? void 0 : _a.isRerequisition);
};
var shouldRenderToggleGenesButton = function (test) {
    var hideGeneCountPanel = shouldHideGeneCountPanel(test);
    var totalGeneCount = getTotalGeneCount(test);
    return !hideGeneCountPanel && totalGeneCount > 0;
};
var shouldRenderGeneCountButton = function (test, hideGenes) {
    var hideGeneCountPanel = shouldHideGeneCountPanel(test);
    var totalGeneCount = getTotalGeneCount(test);
    return !hideGeneCountPanel && !hideGenes && totalGeneCount > 0;
};
var Test = function (props) {
    var handleDeleteTest = props.handleDeleteTest, hideGenes = props.hideGenes, isAddon = props.isAddon, productType = props.productType, test = props.test, url = props.url;
    var _a = useCollapsible(), isOpen = _a.isOpen, setRef = _a.setRef, toggle = _a.toggle;
    var cartContext = React.useContext(CartContext);
    var cartSettings = React.useContext(CartSettingsContext);
    var meta = cartContext.meta;
    var isCompact = cartSettings.isCompact, isEditable = cartSettings.isEditable;
    var genes = test.genes, isCustom = test.isCustom, name = test.name;
    var deleteTest = React.useCallback(function () {
        handleDeleteTest(test);
    }, [handleDeleteTest, test]);
    var conceptNameClassName = React.useMemo(function () {
        if (isAddon) {
            return isCompact ? styles.addOnCompact : styles.addOn;
        }
        else {
            return isCompact ? styles.conceptNameCompact : styles.conceptName;
        }
    }, [isAddon, isCompact]);
    var toggleButtonTitle = React.useMemo(function () {
        return "".concat(isOpen ? 'HIDE' : 'SHOW').concat(hideGenes ? '' : ' GENES');
    }, [isOpen, hideGenes]);
    var isCustomizable = React.useMemo(function () {
        return isCustom && isEditable && !isCompact;
    }, [isCompact, isCustom, isEditable]);
    var fullName = React.useMemo(function () {
        var _a;
        return ((_a = meta === null || meta === void 0 ? void 0 : meta.rereq) === null || _a === void 0 ? void 0 : _a.isRerequisition) ? "".concat(name, ": REPORTED") : name;
    }, [meta, name]);
    var testClassName = React.useMemo(function () {
        return isAddon && !isCompact ? "".concat(styles.test, " ").concat(styles.testAddon) : styles.test;
    }, [isAddon, isCompact]);
    var showSaveCustomPanelButton = shouldShowSaveCustomPanelButton(test);
    var renderDeleteButton = shouldRenderDeleteButton(test, cartContext, cartSettings);
    var renderToggleGenesButton = shouldRenderToggleGenesButton(test);
    var renderGeneCountButton = shouldRenderGeneCountButton(test, hideGenes);
    var totalGeneCount = getTotalGeneCount(test);
    return (React.createElement("div", { "data-testid": "test-".concat(test.name).concat(isAddon ? '-add-on' : '') },
        React.createElement("div", { className: testClassName },
            React.createElement("div", { className: conceptNameClassName, "data-testid": "test-concept-name" },
                React.createElement("div", { className: styles.conceptLabel },
                    url && (React.createElement("a", { "data-testid": "test-name", href: url, onClick: function (e) { return e.stopPropagation(); }, rel: "noopener noreferrer", target: "_blank" }, fullName)),
                    !url && React.createElement("span", { "data-testid": "test-name" }, fullName),
                    renderToggleGenesButton && (React.createElement("button", { className: styles.toggleGenesListBtn, "data-testid": "".concat(test.name, "-toggle-genes-button"), onClick: function (e) {
                            e.stopPropagation();
                            toggle();
                        }, type: "button" }, toggleButtonTitle))),
                React.createElement("div", { className: styles.genesList, ref: setRef },
                    React.createElement(GeneList, { genes: genes, isCustomizable: isCustomizable, productType: productType, shouldShowSaveCustomPanelButton: showSaveCustomPanelButton }))),
            React.createElement("div", { className: styles.testGenesAndRemoveBtn },
                renderGeneCountButton && (React.createElement("button", { className: styles.button, "data-testid": "".concat(test.name, "-gene-count-button"), onClick: function (e) {
                        e.stopPropagation();
                        toggle();
                    } },
                    totalGeneCount,
                    " ",
                    pluralize('gene', genes.length))),
                renderDeleteButton && (React.createElement("button", { className: styles.removeOrderTestButton, "data-testid": "".concat(test.name, "-delete-button"), onClick: deleteTest },
                    React.createElement(DeleteIcon, { isSmall: true })))))));
};

export { Test as default };
//# sourceMappingURL=Test.esm.js.map
